import {
  EditSettingsModel,
  FilterSettingsModel,
  Inject,
  PageSettingsModel,
} from '@syncfusion/ej2-react-grids';
import { Component } from 'react';
import Message from '../../utils/Message/Message';
import moment from 'moment';
import WorkOrders, { g_worder } from './WorkOrders';
import { ThemeContext } from '../../context/theme.context';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import {
  Category,
  ChartComponent,
  Legend,
  SeriesCollectionDirective,
  SeriesDirective,
  StackingColumnSeries,
  Tooltip,
} from '@syncfusion/ej2-react-charts';
import {
  CheckBoxSelection,
  MultiSelectComponent,
} from '@syncfusion/ej2-react-dropdowns';
import GlobalSearch from '../../components/GlobalSearch';
import { GetKanbanColor } from '../../services/CloudScheduler/CloudSchedulerServices';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { BsSearch } from 'react-icons/bs';
import { getMaterialKpi } from '../../services/Materials/MaterialsServices';
import GlobalGrid from '../../components/GlobalGrid';
import { all_information, loadingShow } from '../../App';
import './style.css';
interface IState {
  materialtData: Array<any>;
  PriorityColorData: Array<any>;
  currentIcon: any;
  status: boolean;
  chartData: Array<any>;
  height: number;
  searchText: string;
  current_query: string;
  loadSignal: boolean;
}
interface IProps {
  outter_asset_code?: String | undefined;
}
export class Material extends Component<IProps, IState> {
  private gridMaterial: any;
  public validationRule: Object = { required: true };
  private model: Array<any> = [];
  private searchText: string = '';
  private selectedChip2: Array<any> = [];
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private resultLikeQuery: string = '';
  private statusFilterMultiSelectCom: MultiSelectComponent;
  private material_status: string = '';
  private statusFilterMultiSelectComValue: any;
  private theQueryStatuses = '';
  private theQueryType = '';
  private theQuerySearch = '';
  private theQueryPlanId = '';
  private theQueryOrderCode = '';
  private theQueryOutterAsset = '';
  private current_query: string = '';
  private plan_id: number = 0;
  private order_code: string = '';
  constructor(prop: IProps) {
    super(prop);
    this.state = {
      materialtData: [],
      PriorityColorData: [],
      currentIcon: <FaAngleDown size='14px' />,
      status: true,
      chartData: [],
      height: 100,
      searchText: '',
      current_query: '',
      loadSignal: false,
    };
    this.statusFilterMultiSelectCom = new MultiSelectComponent({});
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };

  public editOptions: EditSettingsModel = {
    allowAdding: false,
    allowDeleting: false,
    allowEditing: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 50,
    pageCount: 8,
    pageSizes: false,
  };
  statusTemplate = (args: any) => {
    var color = '';
    if (args.material_status.trim() === 'Parts_Outstanding') {
      color = '#00B900';
    } else {
      color = 'rgb(54, 69, 79)';
    }
    return (
      <div
        style={{
          backgroundColor: color,
          borderRadius: 7,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <span>{args.material_status}</span>
      </div>
    );
  };
  orderStatusTemplate = (args: any) => {
    var color = '';
    var contentText = '';
    if (args.po_order_status.trim() === '10') {
      color = '#4c6332';
      contentText = '10 - Approval Required';
    }
    if (args.po_order_status.trim() === '11') {
      color = '#C90016';
      contentText = '11 - Back Order';
    }
    if (args.po_order_status.trim() === '20') {
      color = '#2c668c';
      contentText = '20 - Requistion Approval Required';
    }
    if (args.po_order_status.trim() === '40') {
      color = '#F4B400';
      contentText = '40 - On Order';
    }
    if (args.po_order_status.trim() === '70') {
      color = '#bc00dd';
      contentText = '70 - Goods Updated';
    }
    if (args.po_order_status.trim() === '75') {
      color = '#f27130';
      contentText = '75 - Goods Returned';
    }
    if (args.po_order_status.trim() === '90') {
      color = '#00b900';
      contentText = '90 - Completed';
    }
    return (
      <div
        style={{
          backgroundColor: color,
          borderRadius: 7,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <span>{contentText}</span>
      </div>
    );
  };
  private materialColumns = [
    {
      field: 'job_reference',
      headerText: 'Job Reference',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_order_status',
      headerText: 'Order Status',
      textAlign: 'Left',
      validationRules: this.validationRule,
      template: this.orderStatusTemplate.bind(this),
      width: 140,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'cre_accountcode',
      headerText: 'Account Code',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 75,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_number',
      headerText: 'PO Number',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 75,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'item_description',
      headerText: 'Item Description',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 130,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_backorder_flag',
      headerText: 'Backorder Flag',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'pola_line_seq',
      headerText: 'POLA Line Seq',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'supp_stk_code',
      headerText: 'Supp STK Code',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 90,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_item_price',
      headerText: 'Item Price',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 60,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'pal_amount',
      headerText: 'Pal Amount',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 75,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'pal_order_qty',
      headerText: 'PAL Order GTY',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_order_qty',
      headerText: 'Order GTY',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_received_qty',
      headerText: 'Received GTY',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_received_date',
      headerText: 'Received Date',
      format: 'dd/MM/yyyy',
      type: 'date',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 90,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'approval_user',
      headerText: 'Approval User',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 75,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'material_status',
      headerText: 'Material Status',
      textAlign: 'Left',
      validationRules: this.validationRule,
      template: this.statusTemplate.bind(this),
      width: 140,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_order_date',
      headerText: 'Order Date',
      textAlign: 'Left',
      format: 'dd/MM/yyyy',
      type: 'date',
      width: 90,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_action_date',
      headerText: 'Action Date',
      format: 'dd/MM/yyyy',
      type: 'date',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 90,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_arrival_date',
      headerText: 'Arrival Date',
      format: 'dd/MM/yyyy',
      type: 'date',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 90,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'order_suffix',
      headerText: 'Order Sufix',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_whse_code',
      headerText: 'WHSE Code',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 75,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'receiving_whse',
      headerText: 'Receving WHSE',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_order_total',
      headerText: 'Order Total',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 80,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'received_total',
      headerText: 'Received Total',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 75,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_charges_total',
      headerText: 'Charges Total',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },

    {
      field: 'job_cost_centre',
      headerText: 'Cost Centre',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'job_receive_to_site',
      headerText: 'Receive To Site',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_user_name',
      headerText: 'User Name',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 75,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_date_stamp',
      headerText: 'Date Stamp',
      format: 'dd/MM/yyyy',
      type: 'date',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 90,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_order_type',
      headerText: 'Order Type',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'receiver_user_id',
      headerText: 'Receiver User Id',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 75,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_total_qty',
      headerText: 'Total GTY',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'total_line_qty',
      headerText: 'Total Line GTY',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'allocation_code',
      headerText: 'Allocation Code',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'pol_po_number',
      headerText: 'PO Number',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 75,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'pol_backorder_flag',
      headerText: 'POL Backorder Flag',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_l_seq',
      headerText: 'L SEQ',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_line_type',
      headerText: 'Line Type',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'po_backorder_qty',
      headerText: 'Backorder GTY',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'pol_gl_account_code',
      headerText: 'GL Account Code',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 120,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'job_reference',
      headerText: 'Job Reference',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 90,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'requisition_no',
      headerText: 'Requisition No',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 75,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'pal_type',
      headerText: 'PAL Type',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'pola_order_no',
      headerText: 'POLA Order No ',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 75,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'pola_gl_account_code',
      headerText: 'POLA GL Account Code',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 120,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'pal_seq_no',
      headerText: 'PAL SEQ No',
      textAlign: 'Left',
      validationRules: this.validationRule,
      width: 40,
      clipMode: 'EllipsisWithTooltip',
    },
  ];
  templateSearchBar = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          alignSelf: 'flex-end',
          height: 25,
        }}
      >
        <TextBoxComponent
          type={'text'}
          id='materials'
          autocomplete='off'
          input={this.inputEnterPress.bind(this)}
          showClearButton
          placeholder='Search'
          onChange={(args: any) => {
            this.setState({ searchText: args.target.value });
          }}
        />
        <div
          style={{
            borderRightColor: 'transparent',
            borderTopColor: 'transparent',
            borderBottomColor: 'transparent',
          }}
        >
          <BsSearch
            color={this.context.isDarkMode ? '#eaeaea' : '#292525'}
            className={'searchIcon'}
            onClick={this.search.bind(this)}
          />
        </div>
      </div>
    );
  };
  public toolbarOptions: any = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    {
      text: 'Bring All',
      tooltipText: 'Bring all data from Database',
      prefixIcon: 'e-database',
      id: 'bring',
    },
    'ColumnChooser',
    'ExcelExport',
    { template: this.templateSearchBar.bind(this), align: 'Right' },
  ];
  inputEnterPress(e: any) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      this.search();
    }
  }
  removeSearch() {
    if (this.state.searchText !== '') {
      $('#work_orders').val('');
      this.setState({ searchText: '' });
      if (this.resultLikeQuery !== '') {
        this.resultLikeQuery = '';
        this.buildQuery();
      }
    }
  }
  toolbarClickExtends(args: any) {
    if (args.item.id === 'refresh') {
      loadingShow(true,"Loading...")
    }
    
    if (args.item.id === 'bring') {
      this.order_code = '';
      this.model = [];
      this.buildQuery();
    }
    if (this.gridMaterial && args.item.id === 'gridEventStatus_excelexport') {
      this.gridMaterial.excelExport();
    }
  }
  async componentDidMount() {
    this.plan_id = this.context.planId;
    this.order_code = g_worder;
    this.getColor();
    this.buildQuery();
  }
  componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any
  ): void {
    if (this.state != prevState) {
      return;
    }
    if (this.context.isDataChangeMaterials) {
      this.plan_id = this.context.planId;
      this.order_code = g_worder;
      this.model = [];
      this.buildQuery();
      this.context.setDataChangeMaterials(false);
    }
    if (this.context.isMaterialAllowChange) {
      this.plan_id = this.context.planId;
      this.model = [];
      this.buildQuery();
      this.context.setMaterialAllowChange(false);
    }
  }
  buildQuery() {
    this.current_query = this.state.current_query.trimEnd();
    this.current_query = this.current_query.replace(this.theQueryStatuses, '');
    this.current_query = this.current_query.replace(this.theQuerySearch, '');
    this.current_query = this.current_query.replace(this.theQueryPlanId, '');
    this.current_query = this.current_query.replace(this.theQueryOrderCode, '');
    this.current_query = this.current_query.replace(
      this.theQueryOutterAsset,
      ''
    );
    this.theQueryStatuses = '';
    this.theQueryType = '';
    this.theQuerySearch = '';
    this.theQueryOrderCode = '';
    var theStatuses = this.statusFilterMultiSelectCom?.value?.toString();
    var o_asset_code = this.props.outter_asset_code;
    if (theStatuses !== '' && theStatuses !== undefined) {
      if (this.current_query !== '') {
        this.theQueryStatuses = this.addToQuery(
          'po_order_status',
          'in',
          'andWhere',
          theStatuses?.toString(),
          this.theQueryStatuses
        );
      } else {
        this.theQueryStatuses = this.addToQuery(
          'po_order_status',
          'in',
          'where',
          theStatuses?.toString(),
          this.theQueryStatuses
        );
      }
    }
    if (this.plan_id !== 0) {
      if (this.current_query !== '') {
        this.theQueryPlanId = this.addToQuery(
          'ID',
          '=',
          'andWhere',
          this.plan_id?.toString(),
          this.theQueryPlanId
        );
      } else {
        this.theQueryPlanId = this.addToQuery(
          'ID',
          '=',
          'where',
          this.plan_id?.toString(),
          this.theQueryPlanId
        );
      }
    }
    if (this.order_code !== '') {
      if (this.current_query !== '') {
        this.theQueryOrderCode = this.addToQuery(
          'job_reference',
          '=',
          'andWhere',
          this.order_code?.toString(),
          this.theQueryOrderCode
        );
      } else {
        this.theQueryOrderCode = this.addToQuery(
          'job_reference',
          '=',
          'where',
          this.order_code?.toString(),
          this.theQueryOrderCode
        );
      }
    }
    if (o_asset_code !== '' && o_asset_code !== undefined) {
      if (this.current_query !== '') {
        this.theQueryOutterAsset = this.addToQuery(
          'asset_code',
          'in',
          'andWhere',
          o_asset_code.trim(),
          this.theQueryOutterAsset
        );
      } else {
        this.theQueryOutterAsset = this.addToQuery(
          'asset_code',
          'in',
          'where',
          o_asset_code.trim(),
          this.theQueryOutterAsset
        );
      }
    }
    if (this.state.searchText !== '') {
      this.theQuerySearch = '$' + this.state.searchText;
      this.current_query = this.current_query + this.theQuerySearch;
    }
    this.setState({
      current_query: this.current_query + ' ',
      loadSignal: true,
    });
    this.getKpiData('1$10$' + this.current_query);
  }
  addToQuery = (
    field: string,
    c: string,
    type: string,
    v: string,
    current_query: string
  ) => {
    current_query = JSON.stringify({
      f: field,
      c: c,
      t: type,
      v: v,
    });
    current_query += '?';
    this.current_query += current_query;
    return current_query;
  };
  getColor() {
    GetKanbanColor(all_information.company_id?.toString()).then((el) => {
      el.data.map((elCol: any) => {
        $(`.e-chip-text${elCol.priority_code.trim()}`).css(
          'background-color',
          `${elCol?.priority_color}`
        );
      });
      this.setState({ PriorityColorData: el.data });
    });
  }
  convertToDate(val: any) {
    var num = parseInt(val.substring(6, 19));
    var date = moment(num).format('MM/DD/yyyy');
    return date;
  }
  search() {
    if (this.state.searchText !== '' || this.current_query !== '') {
      this.buildQuery();
    }
  }
  generateColor = (status: any) => {
    var color = '';
    var contentText = '';
    if (status.trim() === '10') {
      color = '#4c6332';
      contentText = '10 - Approval Required';
    }
    if (status.trim() === '11') {
      color = '#C90016';
      contentText = '11 - Back Order';
    }
    if (status.trim() === '20') {
      color = '#2c668c';
      contentText = '20 - Requistion Approval Required';
    }
    if (status.trim() === '40') {
      color = '#F4B400';
      contentText = '40 - On Order';
    }
    if (status.trim() === '70') {
      color = '#bc00dd';
      contentText = '70 - Goods Updated';
    }
    if (status.trim() === '75') {
      color = '#f27130';
      contentText = '75 - Goods Returned';
    }
    if (status.trim() === '90') {
      color = '#00b900';
      contentText = '90 - Completed';
    }
    return [{ contentText, color }];
  };
  expand = () => {
    var element = document.getElementById('expandableMaterial');
    if (this.state.status) {
      element?.classList.remove('layoutExpandMaterial');
      element?.classList.add('layoutCollapseMaterial');
      // this.setState({ currentIcon: <FaAngleDown size='14px' /> });
    } else {
      element?.classList.remove('layoutCollapseMaterial');
      element?.classList.add('layoutExpandMaterial');
      // this.setState({ currentIcon: <FaAngleUp size='14px' /> })
    }
    this.setState({
      status: !this.state.status,
      height: this.state.status ? 100 : 50,
      currentIcon: this.state.status ? (
        <FaAngleDown size='14px' />
      ) : (
        <FaAngleUp size='14px' />
      ),
    });
  };
  getKpiData(where: string) {
    getMaterialKpi(where)
      .then((el) => {
        let result = el.data.map((item: any) => {
          return {
            ...item,
            status: this.generateColor(item.status)[0].contentText,
            color: this.generateColor(item.status)[0].color,
          };
        });
        this.setState({
          chartData: result,
        });
      })
      .catch((error) => {
        if (error.response) {
          Message.error(error.response.data);
          Message.error(error.response.status);
          Message.error(error.response.headers);
        } else if (error.request) {
          Message.error(error.request);
        } else {
          Message.error('Error: ' + error.message);
        }
        Message.error(error.config);
      });
  }
  ApplyFilter() {
    var theStatuses = this.statusFilterMultiSelectCom?.value?.toString();
    if(theStatuses != undefined){
      this.material_status = theStatuses;
    }
    this.buildQuery();
  }
  clearFilter() {
    this.searchText = '';
    this.statusFilterMultiSelectCom.value = [];
    this.buildQuery();
  }
  StatusMultiSelect() {
    return (
      <div>
        <MultiSelectComponent
          id='materialFilterMultiStatus'
          ref={(scope: MultiSelectComponent) => {
            this.statusFilterMultiSelectCom = scope;
          }}
          dataSource={[
            { s_code: '00 - Being Entered', id: '00' },
            { s_code: '01 - Periodic Order', id: '01' },
            { s_code: '02 - Quotation Required', id: '02' },
            { s_code: '03 - Quotation Printed', id: '03' },
            { s_code: '04 - Blanket Order', id: '04' },
            { s_code: '06 - Contract', id: '06' },
            { s_code: '10 - Approval Required', id: '10' },
            { s_code: '11 - Back Order', id: '11' },
            { s_code: '13 - Return Approval Required', id: '13' },
            { s_code: '15 - For Transmission', id: '15' },
            { s_code: '20 - Requistion Approval Required', id: '20' },
            { s_code: '21 - Internal Requistion Approved', id: '21' },
            { s_code: '25 - Firm Planned', id: '25' },
            { s_code: '28 - Special Ready to Print', id: '28' },
            { s_code: '30 - Ready to Print', id: '30' },
            { s_code: '33 - Return Ready to Print', id: '33' },
            { s_code: '35 - Special On Order', id: '35' },
            { s_code: '37 - Special Invoice Received', id: '37' },
            { s_code: '40 - On Order', id: '40' },
            { s_code: '41 - In Transit Entered', id: '41' },
            { s_code: '42 - In Transit Stock Updated', id: '42' },
            { s_code: '50 - In Transit', id: '50' },
            { s_code: '51 - In Transit Invoice Updated', id: '51' },
            { s_code: '55 - Ready to Return', id: '55' },
            { s_code: '60 - Goods Received', id: '60' },
            { s_code: '61 - Goods Received Invoice Updated', id: '61' },
            { s_code: '70 - Goods Updated', id: '70' },
            { s_code: '75 - Goods Returned', id: '75' },
            { s_code: '80 - Ready to Post Invoice', id: '80' },
            { s_code: '83 - Return Ready to Update', id: '83' },
            { s_code: '90 - Completed', id: '90' },
            { s_code: '91 - Requisition Ordered', id: '91' },
            { s_code: '92 - Requisition Cancelled', id: '92' },
            { s_code: '93 - Variance Order', id: '93' },
            { s_code: '95 - Internal Requisition Completed', id: '95' },
            { s_code: '99 - Cancelled', id: '99' },
          ]}
          fields={{ value: 'id', text: 's_code' }}
          placeholder='Select a status'
          mode='CheckBox'
          showSelectAll={true}
          enabled={true}
          showClearButton={true}
          showDropDownIcon={true}
          filterBarPlaceholder='Search a status'
          value={this.statusFilterMultiSelectComValue}
          onChange={(e: any) => {
            this.statusFilterMultiSelectComValue = e.value;
          }}
        >
          <Inject services={[CheckBoxSelection]} />
        </MultiSelectComponent>
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className='main' onClick={this.expand.bind(this)}>
          {this.state.currentIcon}
        </div>
        <div id='expandableMaterial' className='layoutMaterial'>
          <div className='w-96 flex flex-col justify-end md:flex-wrap bg-green-300'>
            {this.state.chartData.length > 0 ? (
              <ChartComponent
                style={{ textAlign: 'center' }}
                primaryXAxis={{
                  majorGridLines: { width: 0 },
                  minorGridLines: { width: 0 },
                  majorTickLines: { width: 0 },
                  minorTickLines: { width: 0 },
                  interval: 1,
                  lineStyle: { width: 0 },
                  labelIntersectAction: 'Rotate45',
                  labelStyle: {
                    textOverflow: 'Wrap',
                    color: this.context.isDarkMode
                      ? 'rgb(234,234,234)'
                      : '#15202B',
                    size: '9px',
                    fontFamily: 'Segoe UI',
                    fontStyle: 'normal',
                    fontWeight: '500',
                  },
                  valueType: 'Category',
                }}
                primaryYAxis={{
                  lineStyle: { width: 0 },
                  majorTickLines: { width: 1 },
                  majorGridLines: { width: 0 },
                  minorGridLines: { width: 1 },
                  minorTickLines: { width: 1 },
                  labelStyle: {
                    size: '8px',
                  },
                  labelFormat: '{value}',
                }}
                width={'100%'}
                height={'300px'}
                enableAnimation={true}
                chartArea={{ border: { width: 0 } }}
                tooltip={{ enable: true }}
                background={this.context.isDarkMode ? '#15202B' : '#EAEAEA'}
                legendSettings={{
                  textStyle: {
                    color: this.context.isDarkMode ? '#FFFFFF' : '#15202B',
                    size: '12px',
                    fontFamily: 'Segoe UI',
                    fontStyle: 'normal',
                    fontWeight: '500',
                  },
                  position: 'Top',
                }}
              >
                <Inject
                  services={[StackingColumnSeries, Category, Legend, Tooltip]}
                />
                <SeriesCollectionDirective>
                  {this.state.chartData.map((el: any, index: number) => {
                    return (
                      <SeriesDirective
                        key={Math.random()}
                        dataSource={[this.state.chartData[index]]}
                        xName='status'
                        yName={'count'}
                        name={el.status}
                        type='StackingColumn'
                        fill={el.color}
                      ></SeriesDirective>
                    );
                  })}
                </SeriesCollectionDirective>
              </ChartComponent>
            ) : (
              <div>No data to show</div>
            )}
          </div>
        </div>
        <GlobalSearch
          id={'cloud-planner-material-filter'}
          Component1={this.StatusMultiSelect.bind(this)}
          applyFilter={this.ApplyFilter.bind(this)}
          clearFilter={this.clearFilter.bind(this)}
        />
        <GlobalGrid
          columns={this.materialColumns}
          query={this.state.current_query}
          signalOfLoad={this.state.loadSignal}
          get_query={'material'}
          id={'cloud-planner-material-grid'}
          additinalToolbarClick={this.toolbarClickExtends.bind(this)}
          toolbarOptions={this.toolbarOptions}
          height={'calc(-290px + 100vh)'}
          theEditOptions={this.editOptions}
        />
      </div>
    );
  }
}

export default Material;
